import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectMsgNotifications } from "../features/msgNotification/msgNotificationSlice";

const CustomerGreetings = () => {
  const message = useSelector(selectMsgNotifications);
  const time = message?.time?.slice(0, 5);
  return (
    <div className="m-10">
      <h1 className="text-3xl text-[#008556] font-semibold mb-4">
        Hello, {message?.name}!
      </h1>
      <span className="font-semibold italic text-xs">
        Last Login {message?.date} at {time}
      </span>
    </div>
  );
};

export default CustomerGreetings;
